<mat-card>
  <mat-card-header>
    <mat-card-subtitle>
      <ng-container *ngIf="responseSvc.isAlreadyManaged(opinion?.response_obj)">
        <mark>La demande a été traitée par un gestionnaire</mark><br/>
      </ng-container>
      {{displayOpinionType()}}
    </mat-card-subtitle>
  </mat-card-header>
  <app-opinions-visualize *ngIf="visibilityAvis && response?.id"
                          [response]="response"></app-opinions-visualize>
  <mat-card-content *ngIf="opinion">
    <mat-drawer-container class="ex-container" autosize *ngIf="response">
      <mat-drawer #drawer class="ex-sidenav" mode="side" opened position="end">
        <button (click)="drawer.toggle()" *ngIf="drawer.opened"
                [matTooltip]="'Masquer la fiche de réponse'"
                mat-mini-fab
                [color]="'primary'"
                type="button">
          <mat-icon>close</mat-icon>
        </button>
        <app-simple-reponse-fiche [response]="response"></app-simple-reponse-fiche>
      </mat-drawer>
      <div class="ex-sidenav-content">
        <form [formGroup]="opinionForm" fxLayout="column">
          <mat-radio-group formControlName="avis" fxLayout="column" [disabled]="readOnlyOpinion">
            <mat-label fxLayout="row" fxLayoutAlign="space-between center">
              <span>Avis :</span>
              <button (click)="drawer.toggle()" *ngIf="!drawer.opened"
                      [matTooltip]="'Afficher la fiche de réponse'"
                      mat-mini-fab
                      [color]="'accent'"
                      type="button">
                <mat-icon>visibility</mat-icon>
              </button>
            </mat-label>
            <mat-radio-button [value]="AvisEnum.favorable">
              {{AvisEnum.toString(AvisEnum.favorable)}}
            </mat-radio-button>
            <mat-radio-button [value]="AvisEnum.unfavorable">
              {{AvisEnum.toString(AvisEnum.unfavorable)}}
            </mat-radio-button>
            <mat-radio-button [value]="AvisEnum.suspended_other">
              {{AvisEnum.toString(AvisEnum.suspended_other)}}
            </mat-radio-button>
          </mat-radio-group>
          <br/>
          <mat-form-field>
            <mat-label>Motivation</mat-label>
            <textarea matInput formControlName="motivation" [disabled]="readOnlyOpinion"></textarea>
          </mat-form-field>
          <br/>
        </form>
        <div>
          <mat-label>Pièce jointe</mat-label>
          <div *ngIf="!hasDownload && !readOnlyOpinion">
            <p8-attachments
              [simpleView]="false"
              [accept]="extensionsFiles"
              [labelJoin]="'Choisir le fichier'"
              [typeButton]="'label'"
              [buttonSelectIcon]="'attach_file'"
              [buttonIconAlign]="'start'"
              [maxFiles]="1"
              [colorButton]="'accent'"
              [maxFileSize]="maxFilesize"
              [application]="application"
              [connector]="uploaderConnector"
              (onFinished)="handleFilesUploaded($event)"
              (onUpdatedFiles)="setMetaFile($event)">
            </p8-attachments>
            <div fxLayoutAlign="end center">
              <button *ngIf="hasAttachments"
                      mat-stroked-button
                      (click)="uploadFile()"
                      [matTooltip]="'cliquer pour démarrer le téléversement de ce fichier'"
                      color="accent"
                      [disabled]="uploading">
                Lancer le téléversement de ce fichier
                <mat-icon>file_upload</mat-icon>
              </button>
            </div>
          </div>
          <div *ngFor="let attachement of opinion.attachment_obj">
            {{filename(attachement)}}
            <button mat-icon-button (click)="onDownload(attachement)" [disabled]="downloading"
                    matTooltip="Télécharger {{filename(attachement)}}">
              <mat-icon color="primary">file_download</mat-icon>
            </button>
            <button mat-icon-button (click)="onDelete(attachement)" *ngIf="!readOnlyOpinion"
                    matTooltip="Supprimer {{filename(attachement)}}">
              <mat-icon color="warn">delete_outline</mat-icon>
            </button>
          </div>
        </div>
      </div>

    </mat-drawer-container>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-raised-button (click)="saveOpinion()" [disabled]="opinionForm.invalid" *ngIf="!readOnlyOpinion" data-cy="btn-opinion-save">Envoyer</button>
  </mat-card-actions>
</mat-card>
